import { useTheme } from 'styled-components';

interface IProps {
  /** JSX|String component */
  label: React.ReactNode | string;

  value: string | number | readonly string[] | undefined;

  /** if the button is disabled, user can't click. */
  disabled?: boolean;

  /** when user clicks on the button, function will be called */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;

  checked?: boolean;
}

export const Checkbox: React.FC<IProps> = ({
  label,
  value,
  onChange,
  checked = false,
  disabled = false,
}) => {
  const theme: any = useTheme();

  return (
    <div>
      <label className="inline-flex items-center">
        <input
          type="checkbox"
          className={`
            rounded 
            border-gray-300 
            text-${theme.current}-primary 
            shadow-sm 
            focus:border-${theme.current}-primary 
            focus:ring 
            focus:ring-offset-0 
            focus:ring-${theme.current}-light 
            focus:ring-opacity-50
          `}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <span className="ml-2 cursor-pointer">{label}</span>
      </label>
    </div>
  );
};
